import React from "react";
import Modal from "react-modal";
import { useQuery } from "@apollo/client";
import { useNavigate, useLocation } from "react-router-dom";

import BeneficiaryDetailTable from "./components/BeneficiaryDetailTable";
import InsurancePlanTable from "./components/InsurancePlanTable";
import beneficiary from "../../gql/beneficiary";
import { useTranslation } from "react-i18next";
import { CheckCircle } from "@mui/icons-material";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    minWidth: "95%",
    maxHeight: "90%",
  },
};

function BeneficiaryDetails(props) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const item = location.state?.item ? location.state.item : null;

  const { loading, error, data, refetch } = useQuery(
    beneficiary.GET_PATIENT_BY_ID,
    {
      variables: { id: item?.id ?? item?._id },
      fetchPolicy: "network-only",
    },
  );

  const onClickEdit = (el) => {
    navigate("/beneficiary/edit/form", { state: { item: item } });
  };

  return (
    <div className="patient-info">
      {/* <div className=" rounded-[8px] border mb-2 flex items-start gap-2 p-2 bg-white"> */}
      {/* <div
          className="back flex items-center justify-center cursor-pointer transition-all duration-200 hover:opacity-80 active:scale-95 mt-1"
          onClick={() => navigate(-1)}
          style={{
            backgroundColor: "#0070C2",
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          {i18n.language === "en" ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M9 19L10.41 17.59L5.83 13H22V11H5.83L10.42 6.41L9 5L2 12L9 19Z"
                fill="white"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
            >
              <g transform="scale(-1,1) translate(-24,0)">
                <path
                  d="M9 19L10.41 17.59L5.83 13H22V11H5.83L10.42 6.41L9 5L2 12L9 19Z"
                  fill="white"
                />
              </g>
            </svg>
          )}
        </div> */}
      {/* <div>
          <div className="text-[20px] font-bold ">
            <span>{t("Patient Information")}</span>
          </div>
          <div className="text-[14px] text-[#667085]">
            <span>{t("View Patient Information")}</span>
          </div>
        </div> */}
      {/* </div> */}

      <div
        style={{
          marginTop: "6px",
          border: "1px solid #E4E7EC",
          borderRadius: "8px",
          overflow: "hidden",
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            backgroundColor: "#F9FAFB",
            padding: "6px 12px",
            borderBottom: "1px solid #E4E7EC",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <div
            className="back flex items-center justify-center cursor-pointer transition-all duration-200 hover:opacity-80 active:scale-95 mt-1"
            onClick={() => navigate(-1)}
            style={{
              backgroundColor: "#0070C2",
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            {i18n.language === "en" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9 19L10.41 17.59L5.83 13H22V11H5.83L10.42 6.41L9 5L2 12L9 19Z"
                  fill="white"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g transform="scale(-1,1) translate(-24,0)">
                  <path
                    d="M9 19L10.41 17.59L5.83 13H22V11H5.83L10.42 6.41L9 5L2 12L9 19Z"
                    fill="white"
                  />
                </g>
              </svg>
            )}
          </div>
          <svg
            width="24"
            height="24"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="34" height="34" rx="8" fill="#F4F6F8" />
            <path
              d="M24 9H19.82C19.4 7.84 18.3 7 17 7C15.7 7 14.6 7.84 14.18 9H10C8.9 9 8 9.9 8 11V25C8 26.1 8.9 27 10 27H24C25.1 27 26 26.1 26 25V11C26 9.9 25.1 9 24 9ZM17 8.75C17.41 8.75 17.75 9.09 17.75 9.5C17.75 9.91 17.41 10.25 17 10.25C16.59 10.25 16.25 9.91 16.25 9.5C16.25 9.09 16.59 8.75 17 8.75ZM24 25H10V11H24V25Z"
              fill="#0070C2"
            />
            <path
              d="M20.08 17.03L17.96 14.91L12 20.86V23H14.1L20.08 17.03Z"
              fill="#0070C2"
            />
            <path
              d="M21.85 15.27C22.05 15.07 22.05 14.76 21.85 14.56L20.44 13.15C20.24 12.95 19.93 12.95 19.73 13.15L18.67 14.21L20.79 16.33L21.85 15.27Z"
              fill="#0070C2"
            />
          </svg>
          <span
            style={{
              fontSize: "14px",
              fontWeight: "700",
              color: "#344054",
              textTransform: "uppercase",
            }}
          >
            {t("Patient Details")}
          </span>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(6, 1fr)",
            gap: "6px 12px",
            padding: "8px 12px",
          }}
        >
          {[
            { label: "First Name", value: data?.getPatient?.data?.first_name },
            {
              label: "Second Name",
              value: data?.getPatient?.data?.middle_name,
            },
            { label: "Third Name", value: data?.getPatient?.data?.last_name },
            {
              label: "Family Name",
              value: data?.getPatient?.data?.family_name,
            },
            { label: "Full Name", value: data?.getPatient?.data?.full_name },
            {
              label: "Beneficiary File Id",
              value: data?.getPatient?.data?.beneficiary_file_id,
            },
            { label: "DOB", value: data?.getPatient?.data?.dob },
            { label: "E-Health-Id", value: data?.getPatient?.data?.eHealth_id },
            {
              label: "Nationality",
              value: data?.getPatient?.data?.nationality,
            },
            {
              label: "Residency Type",
              value: data?.getPatient?.data?.residency_type,
            },
            { label: "Email", value: data?.getPatient?.data?.email },
            { label: "Nphies Id", value: data?.getPatient?.data?.nphies_id },
            {
              label: "Document Type",
              value: data?.getPatient?.data?.document_type,
            },
            {
              label: "Document ID",
              value: data?.getPatient?.data?.document_id,
            },
            {
              label: "Contact Number",
              value: data?.getPatient?.data?.contact_number,
            },
            {
              label: "Marital Status",
              value: data?.getPatient?.data?.martial_status,
            },
            { label: "Gender", value: data?.getPatient?.data?.gender },
            {
              label: "Blood Group",
              value: data?.getPatient?.data?.blood_group,
            },
            {
              label: "Emergency Ph No",
              value: data?.getPatient?.data?.emergency_number,
            },
            { label: "File Number", value: data?.getPatient?.data?.file_no },
            {
              label: "Preferred Language",
              value: data?.getPatient?.data?.preferred_language,
            },
            {
              label: "Is New Born",
              value: data?.getPatient?.data?.is_new_born ? "Yes" : "No",
            },
            {
              label: "Subscriber ID",
              value: data?.getPatient?.data?.subscriber_id,
            },
            {
              label: "Subscriber Name",
              value: data?.getPatient?.data?.subscriber_name,
            },
            {
              label: "Subscriber Relationship",
              value: data?.getPatient?.data?.subscriber_relationship,
            },
            { label: "Visa Title", value: data?.getPatient?.data?.visa_title },
            {
              label: "Visa Number",
              value: data?.getPatient?.data?.visa_number,
            },
            { label: "Visa Type", value: data?.getPatient?.data?.visa_type },
            {
              label: "Passport Number",
              value: data?.getPatient?.data?.passport_number,
            },
            {
              label: "Border Number",
              value: data?.getPatient?.data?.border_number,
            },
          ].map((item, index) => (
            <div
              key={index}
              style={{ display: "flex", flexDirection: "column", minWidth: 0 }}
            >
              <span
                style={{
                  fontSize: "10px",
                  fontWeight: "600",
                  color: "#667085",
                  textTransform: "uppercase",
                  letterSpacing: "0.025em",
                }}
              >
                {t(item.label)}
              </span>
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: "700",
                  color: "#101828",
                  truncate: true,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  marginTop: "1px",
                }}
              >
                {item.value ?? "-"}
              </span>
            </div>
          ))}
        </div>

        <div
          style={{
            padding: "2px 12px",
            fontSize: "14px",
            fontWeight: "700",
            color: "#344054",
            borderTop: "1px solid #E4E7EC",
            borderBottom: "1px solid #E4E7EC",
            backgroundColor: "#F2F4F7",
            display: "flex",
            alignItems: "center",
            gap: "80px",
          }}
        >
          <div
            style={{
              // backgroundColor: "#F9FAFB",
              // borderBottom: "1px solid #E4E7EC",
              display: "flex",
              alignItems: "center",
              gap: "80px",
            }}
          >
            <div className="flex space-x-1">
              <svg
                width="24"
                height="24"
                viewBox="0 0 34 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="34" height="34" rx="8" fill="#F4F6F8" />
                <path
                  d="M17 17C15.9 17 15 16.1 15 15C15 13.9 15.9 13 17 13C18.1 13 19 13.9 19 15C19 16.1 18.1 17 17 17ZM23 15.2C23 11.57 20.35 9 17 9C13.65 9 11 11.57 11 15.2C11 17.54 12.95 20.64 17 24.34C21.05 20.64 23 17.54 23 15.2ZM17 7C21.2 7 25 10.22 25 15.2C25 18.52 22.33 22.45 17 27C11.67 22.45 9 18.52 9 15.2C9 10.22 12.8 7 17 7Z"
                  fill="#0070C2"
                />
              </svg>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  color: "#344054",
                  textTransform: "uppercase",
                }}
              >
                {t("Address")}
              </span>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(6, 1fr)",
                gap: "6px 20px",
                padding: "8px 12px",
              }}
            >
              {[
                {
                  label: "Address Line",
                  value: data?.getPatient?.data?.address_line,
                },
                {
                  label: "Street Line",
                  value: data?.getPatient?.data?.street_line,
                },
                { label: "City", value: data?.getPatient?.data?.city },
                { label: "State", value: data?.getPatient?.data?.state },
                { label: "Country", value: data?.getPatient?.data?.country },
                {
                  label: "Postal Code",
                  value: data?.getPatient?.data?.postal_code,
                },
              ].map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    minWidth: 0,
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "700",

                      color: "#667085",
                      textTransform: "uppercase",
                      letterSpacing: "0.025em",
                    }}
                  >
                    {t(item.label)} :
                  </span>
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: "700",
                      color: "#101828",
                      truncate: true,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      marginTop: "1px",
                    }}
                  >
                    {item.value ?? " __"}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {(data?.getPatient?.data?.insurance_plans ?? [])?.map((plan, index) => (
        <div
          key={index}
          style={{
            marginTop: "6px",
            border: "1px solid #E4E7EC",
            borderRadius: "8px",
            overflow: "hidden",
            backgroundColor: "white",
          }}
        >
          <div
            style={{
              backgroundColor: "#F9FAFB",
              padding: "6px 12px",
              borderBottom: "1px solid #E4E7EC",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "8px",
            }}
          >
            <div className="flex space-x-2">
              <svg
                width="24"
                height="24"
                viewBox="0 0 34 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="34" height="34" rx="8" fill="#F4F6F8" />
                <path
                  d="M24 9H19.82C19.4 7.84 18.3 7 17 7C15.7 7 14.6 7.84 14.18 9H10C8.9 9 8 9.9 8 11V25C8 26.1 8.9 27 10 27H24C25.1 27 26 26.1 26 25V11C26 9.9 25.1 9 24 9ZM17 8.75C17.41 8.75 17.75 9.09 17.75 9.5C17.75 9.91 17.41 10.25 17 10.25C16.59 10.25 16.25 9.91 16.25 9.5C16.25 9.09 16.59 8.75 17 8.75ZM24 25H10V11H24V25Z"
                  fill="#0070C2"
                />
                <path
                  d="M20.08 17.03L17.96 14.91L12 20.86V23H14.1L20.08 17.03Z"
                  fill="#0070C2"
                />
                <path
                  d="M21.85 15.27C22.05 15.07 22.05 14.76 21.85 14.56L20.44 13.15C20.24 12.95 19.93 12.95 19.73 13.15L18.67 14.21L20.79 16.33L21.85 15.27Z"
                  fill="#0070C2"
                />
              </svg>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  color: "#344054",
                  textTransform: "uppercase",
                }}
              >
                {t("Insurance Plan")} - {index + 1}
              </span>
            </div>
            {plan?.is_primary && (
              <span className="flex items-center space-x-2">
                <CheckCircle
                  className="text-[10px] text-green-500"
                  style={{ fontSize: "16px" }}
                />
                {t("Primary")}
              </span>
            )}
          </div>
          {/* <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(6, 1fr)",
            gap: "6px 12px",
            padding: "8px 12px",
          }}
        >
          {[
            {
              label: "Payer",
              value:
                plan?.payer?.name_en,
              spanTwoColumns: true,
            },
            {
              label: "Issue Date",
              value: plan?.issue_date,
            },
            {
              label: "Expiry Date",
              value: plan?.expiry_date,
            },
            {
              label: "Relation with Subscriber",
              value:
                plan?.relation_with_subscriber,
            },
            {
              label: "Member Card ID",
              value:
                plan?.member_card_id,
            },
            {
              label: "Policy Number",
              value:
                plan?.policy_number,
            },
            {
              label: "Patient Share",
              value:
                plan?.patient_share,
            },
            {
              label: "Max Limit",
              value: plan?.max_limit,
            },
            {
              label: "Network ID",
              value: plan?.network,
            },
            {
              label: "Coverage Type",
              value:
                plan?.coverage_type,
            },
            {
              label: "Sponsor Number",
              value: plan?.sponsor_no,
            },
            {
              label: "Policy Class Name",
              value:
                plan?.policy_class_name,
            },
            {
              label: "Policy Holder",
              value:
                plan?.policy_holder,
            },
            {
              label: "Insurance Status",
              value:
                plan?.insurance_status,
            },
            {
              label: "Insurance Type",
              value:
                plan?.insurance_type,
            },
            {
              label: "Insurance Duration",
              value:
                plan?.insurance_duration,
            },
          ].map((item, index) => (
            <div
              key={index}
              style={{ display: "flex", flexDirection: "column", minWidth: 0 }}
            >
              <span
                style={{
                  fontSize: "10px",
                  fontWeight: "600",
                  color: "#667085",
                  textTransform: "uppercase",
                  letterSpacing: "0.025em",
                }}
              >
                {t(item.label)}
              </span>
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: "700",
                  color: "#101828",
                  truncate: true,
                  // whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  marginTop: "1px",
                }}
              >
                {item.value || "-"}
              </span>
            </div>
          ))}
        </div> */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(6, 1fr)", // 6 columns
              gap: "6px 12px",
              padding: "8px 12px",
            }}
          >
            {[
              {
                label: "Payer",
                value: plan?.payer?.name_en,
                spanTwoColumns: true, // Specify that this item should span 2 columns
              },
              {
                label: "Issue Date",
                value: plan?.issue_date,
              },
              {
                label: "Expiry Date",
                value: plan?.expiry_date,
              },
              {
                label: "Relation with Subscriber",
                value: plan?.relation_with_subscriber,
              },
              {
                label: "Member Card ID",
                value: plan?.member_card_id,
              },
              {
                label: "Policy Number",
                value: plan?.policy_number,
              },
              {
                label: "Patient Share",
                value: plan?.patient_share,
              },
              {
                label: "Max Limit",
                value: plan?.max_limit,
              },
              {
                label: "Network ID",
                value: plan?.network,
              },
              {
                label: "Coverage Type",
                value: plan?.coverage_type,
              },
              {
                label: "Sponsor Number",
                value: plan?.sponsor_no,
              },
              {
                label: "Policy Class Name",
                value: plan?.policy_class_name,
              },
              {
                label: "Policy Holder",
                value: plan?.policy_holder,
              },
              {
                label: "Insurance Status",
                value: plan?.insurance_status,
              },
              {
                label: "Insurance Type",
                value: plan?.insurance_type,
              },
              {
                label: "Insurance Duration",
                value: plan?.insurance_duration,
              },
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: 0,
                  gridColumn: item.spanTwoColumns ? "span 2" : "auto", // Apply 2-column span for "Payer"
                }}
              >
                <span
                  style={{
                    fontSize: "10px",
                    fontWeight: "600",
                    color: "#667085",
                    textTransform: "uppercase",
                    letterSpacing: "0.025em",
                  }}
                >
                  {t(item.label)}
                </span>
                <span
                  style={{
                    fontSize: "11px",
                    fontWeight: "700",
                    color: "#101828",
                    textOverflow: "ellipsis",
                    marginTop: "1px",
                  }}
                >
                  {item.value ?? "-"}
                </span>
              </div>
            ))}
          </div>

          {/* Coverage Class Sub-section */}
          <div
            style={{
              padding: "2px 12px",
              fontSize: "14px",
              fontWeight: "700",
              color: "#344054",
              backgroundColor: "#F2F4F7",
              borderTop: "1px solid #E4E7EC",
              borderBottom: "1px solid #E4E7EC",
              display: "flex",
              alignItems: "center",
              gap: "80px",
            }}
          >
            <div className="flex space-x-2 items-center">
              <svg
                width="24"
                height="24"
                viewBox="0 0 34 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="34" height="34" rx="8" fill="#F4F6F8" />
                <path
                  d="M17 8L10 11V16C10 19.55 13.08 22.74 17 23.61C20.92 22.74 24 19.55 24 16V11L17 8ZM17 17.99H22C21.57 20.08 19.55 21.8 17 22.46V18H12V13.21L17 11.12V17.99Z"
                  fill="#0070C2"
                />
              </svg>

              {/* Coverage Class Title */}
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "700",
                  color: "#344054",
                  textTransform: "uppercase",
                }}
              >
                {t("Coverage Class")}
              </span>
            </div>
            <div
              style={{
                flex: 1,
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "6px 20px",
                padding: "8px 12px",
              }}
            >
              {[
                {
                  label: "Class ID",
                  value: plan?.policy_class_id,
                },
                {
                  label: "Class Type",
                  value: plan?.policy_class_type,
                },
                {
                  label: "Class Name",
                  value: plan?.policy_class_name,
                },
              ].map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    minWidth: 0,
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "700",
                      color: "#667085",
                      textTransform: "uppercase",
                      letterSpacing: "0.025em",
                    }}
                  >
                    {t(item.label)} :
                  </span>
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "700",
                      color: "#101828",
                      truncate: true,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item.value ?? "-"}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default BeneficiaryDetails;
